import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<Ui::LoadingState />\n",{ moduleName: "uplisting-frontend/pods/loading/template.hbs" })